import { Link } from "react-router-dom";
import SVG from "../../SVG";
export default function Items({
  svg_name,
  title,
  isActive = false,
  haveNotifications = false,
  notifCount = null,
  href = "",
  showTitle = true,
  onClick = () => {},
}) {
  return (
    <Link
      to={href}
      onClick={onClick}
      className={`relative min-w-max p-2 flex items-center gap-5 cursor-pointer hocus:bg-gray-200 dark:hocus:bg-white/5 rounded-lg outline-none ${
        isActive && "bg-zi-gradient-button-blue drop-shadow-md"
      }`}
    >
      <SVG
        name={svg_name}
        classname={`w-5 
          ${isActive ? "stroke-white" : "stroke-zi-blue-dark dark:stroke-white"} 
          `}
      />
      {showTitle && (
        <p
          className={`text-xs font-light ${
            isActive
              ? "text-white drop-shadow-md"
              : "text-zi-text-light dark:text-zi-text-dark"
          }`}
        >
          {title}
        </p>
      )}
      {haveNotifications && !showTitle && (
        <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-red-500" />
      )}
      {haveNotifications && showTitle && (
        <div
          className={`absolute flex justify-end items-center gap-1 left-1 top-1/2 -translate-y-1/2 rounded-full ${isActive ? "bg-zi-bg1-light" : "bg-zi-blue-light"} dark:bg-zi-bg1-light py-1 px-2 text-[10px] font-thin ${isActive ? "text-zi-text-light" : "text-zi-text-dark"} dark:text-zi-text-light`}
        >
          <span>{notifCount || 0}</span>
          <span>مورد جدید</span>
        </div>
      )}
    </Link>
  );
}
